import {TextField} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React from 'react';
import getTranslated from '../locale/getTranslated';

export default ({options, label, setValue, name, translateTo, ...props}) => (
  <Autocomplete
    options={options}
    defaultValue={options.filter((item) => item.id === props.value)[0]}
    getOptionLabel={(option) => option ? translateTo ? getTranslated(option.name|| option.themeName, translateTo) : option.name : options[0].name}
    onChange={(event, value) => value && setValue(name, value?.id ? value.id : '')}
    getOptionSelected={(option, value) => option.id === value.id || option.id === value}
    disableClearable
    fullWidth
    {...props}
    value={options.filter((item) => item.id === props.value)[0]}
    renderInput={(params) => (<TextField {...params} label={label} size="small"/>)}
  />
);
